/**
 * Export loadData calls from ducks modules of different containers
 */
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadRealEstateData as RealEstateSearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as UsersPageLoader } from './UsersPage/modules/usersPage.creators';
import { loadData as AircraftRegistrationPageLoader } from './AircraftRegistrationPage/AircraftRegistrationPage.duck';
import { loadData as RegistrationPhotosPageLoader } from './RegistrationPhotosPage/RegistrationPhotosPage.duck';
import { loadData as AircraftRegistrationsPageLoader } from './AircraftRegistrationsPage/AircraftRegistrationsPage.duck';
import { loadData as AircraftParentLandingPageLoader } from './AircraftParentLandingPage/AircraftParentLandingPage.duck';
import { loadData as AirPricingPageLoader } from './AirPricingPage/AirPricingPage.duck';
import { loadData as FavoritesPageLoader } from './FavoritesPage/FavoritesPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
      loadRealEstateData: RealEstateSearchPageLoader,
    },
    UsersPage: {
      loadData: UsersPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    AircraftRegistrationPage: {
      loadData: AircraftRegistrationPageLoader,
    },
    RegistrationPhotosPage: {
      loadData: RegistrationPhotosPageLoader,
    },
    AircraftRegistrationsPage: {
      loadData: AircraftRegistrationsPageLoader,
    },
    AircraftParentLandingPage: {
      loadData: AircraftParentLandingPageLoader,
    },
    AirPricingPage: {
      loadData: AirPricingPageLoader,
    },
    FavoritesPage: {
      loadData: FavoritesPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
